import { 
    GET_PRODUCTS,
    GET_PRODUCT,
    GET_PRODUCTS_WITH_IDS,
    GET_MASTER_TAGS,
    GET_PRODUCT_GROUPS_FOR_PRODUCT
} from '../constants/action-types';
import { UUID } from '../../helpers/uuid';
import { IncludeType } from '../actions/ProductActions';

// INITIALIZE STATE
const initialState = {
    products: {},
    product: {},
    masterTags: [],
    includedInProductGroups: [],
    excludedFromProductGroups: [],
};

// REDUCER
export const ProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_PRODUCTS: {
            return {
                ...state,
                products: action.payload,
            }
        }
        case GET_MASTER_TAGS: {
            return {
                ...state,
                masterTags: action.payload,
            }
        }
        case GET_PRODUCTS_WITH_IDS: {
            const retrievedProducts = action.payload;
            const products = Object.assign({}, state.products);

            retrievedProducts.forEach((retrievedProduct) => {
                products[retrievedProduct.id] = retrievedProduct;
            })

            return {
                ...state,
                products,
            }
        }
        case GET_PRODUCT: {
            const products = Object.assign({}, state.products);

            let incomingProduct = {};

            if (products.hasOwnProperty(action.payload)) {
                incomingProduct = products[action.payload];
            }

            return {
                ...state,
                product: incomingProduct,
            }
        }
        case GET_PRODUCT_GROUPS_FOR_PRODUCT: {
            const productGroupsForProduct = action.payload.data;
            const inclusiveType = action.payload.inclusiveType;

            if (inclusiveType === IncludeType.Include) {
                return {
                    ...state,
                    includedInProductGroups: productGroupsForProduct,
                }
            } else {
                return {
                    ...state,
                    excludedFromProductGroups: productGroupsForProduct,
                }
            }
        }
        default:
            return state;
    }
};